import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import BankPaymentLoader from "@/components/ui/bankPayment/BankPaymentLoader";

const PaymentProcessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("t");

  // Always show loading state while processing
  return <BankPaymentLoader />;
};

export default PaymentProcessPage;
